import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Url from '../../../data/url';
import toast from 'react-hot-toast';
import TopHeaderWithPrev from '../../../component/common/TopHeaderWithPrev';
import FullHeightContainer from '../../../component/common/FullHeightContainer';
import { communityApi } from '../../../assets/api/apis';
import moment from 'moment';
import { useTranslation } from '../../../hook/useTranslation';

function NoticePage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const [notices, setNotices] = useState([]);

  useEffect(() => {
    const fetchNotices = async () => {
      try {
        const noticeRes: any = await communityApi.getNoticeList();
        if (noticeRes.status === 200) {
          setNotices(noticeRes.data);
        }
      } catch (error) {
        console.error('Error fetching notices:', error);
        toast.error(t('community.notice.toast_load_fail'));
      }
    };
    fetchNotices();
  }, [t]);

  const toggleAccordion = (index: number) => {
    setOpenIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <FullHeightContainer>
      <TopHeaderWithPrev title={t('my.notice')} onClickPrev={() => navigate(Url.My)} />
      <div className="pageInner bg-[#FFF]">
        <div className="w-full flex flex-col items-center justify-start mt-4">
          {notices.map((notice: any, index) => (
            <div key={index} className="w-full border-b border-[#EAEAEA]">
              <div
                className="w-full py-[16px] flex flex-col justify-start items-start cursor-pointer"
                onClick={() => toggleAccordion(index)}
              >
                <div className="w-full text-left font-[400] text-[16px] text-[#363636] leading-[1.4] mb-[4px]">
                  {notice.title}
                </div>
                <div className="w-full text-left font-[400] text-[12px] text-[#969696]">
                  {moment(notice.createdAt).format('YYYY.MM.DD')}
                </div>
              </div>
              <div
                className={`w-full overflow-hidden transition-all duration-300 ease-in-out ${
                  openIndex === index ? 'max-h-[1000px] opacity-100 pb-[16px]' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="w-full p-[16px] bg-[#F8F8F8] rounded-[8px] text-[14px] text-[#5D5D5D] leading-[1.5] text-left">
                  {notice.content?.split('\n').map((line: any, i: any) => (
                    <span key={i}>
                      {line}
                      <br />
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </FullHeightContainer>
  );
}

export default NoticePage;
